/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum QuestionType {
    SINGLE_CHOICE = 'singleChoice',
    MULTIPLE_CHOICE = 'multipleChoice',
}
